import { useQuery } from '@tanstack/react-query';

const useNewsList = () => {
  return useQuery({
    queryKey: ['news'],
    queryFn: async () => {
      const response = await fetch(
        import.meta.env.VITE_PAWFRIENDS_API_ENDPOINT_NEWS
      );
      if (!response.ok) {
        throw new Error('Failed to fetch news');
      }
      const data = await response.json();

      // mapiraj datume u Date objekte
      const parsedData = data.map(post => ({
        ...post,
        date: post.date ? new Date(post.date) : null,
      }));

      return parsedData;
    },
    staleTime: 1000 * 60 * 30, // 30 minuta
  });
};

export default useNewsList;
